<template>
    <form-component id="survey-multiple-choice-input" v-if="!loading">
        <input-select v-if="use_dropdown" 
            :value="dropdown_answer"
            @input="selection_dropdown_change"
            label=""
            :options="options"
        />
        <input-button-list v-else
            :value="answer.selections || []" 
            @input="selection_buttons_change"
            label=""
            :allowTwoStack="true"
            :multiple="multiple"
            :options="options"
            :forceFullWidthInputs="true"
        />
        <div :key="follow_up.id" v-for="follow_up in follow_ups" >
            <div>
                <label> {{follow_up.followup_question}} </label>
            </div>
            <textarea 
                :value="answer.follow_up"
                @input="followup_change"
                class="comment"
                :maxlength="500"
            />
        </div>
    </form-component>
</template>

<script>
import InputButtonList from "@/components/inputs/InputButtonList.vue";
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import FormComponent from '@/components/FormComponent.vue';

export default {
    components: {
        InputButtonList,
        InputTextArea,
        InputSelect,
        FormComponent,
    },
    props:{
        value:{
            type: Object,
            default: () => ({
                selections: [],
                follow_up: ""
            })
        },
        multiple: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            required: true
        }
    },
    data(){
        return {
            answer: this.value,
            loading: false,
            dropdown_answer: '',
        }
    },
    methods:{
        selection_buttons_change(value) {
            this.answer.selections = value
            this.$emit('input', this.answer)
        },
        selection_dropdown_change(value) {
            this.answer.selections = value ? [value] : []
            this.$emit('input', this.answer)
        },
        followup_change(e) {
            this.answer.follow_up = e.target.value
            this.$emit('input', this.answer)
        }
    },
    watch: {
        value() {
            this.answer = this.value ? this.value : { selections: [], follow_up: "" }
            if(this.value.selections && this.value.selections.length)
                this.dropdown_answer = this.value.selections[0];
        }
    },
    computed: {
        use_dropdown() {
            return this.options.length > 20 && !this.multiple;
        },
        follow_ups() {
            return this.options.filter(option => 
                option.requires_followup && this.answer.selections.includes(option.id)
            )
        }
    }
}
</script>

<style lang="scss">
#survey-multiple-choice-input {
    @include label;

    .comment {
        width: 100%;
        min-height: 150px;
        resize: none;
        background-color: $textbox-bg-color;
        color: $white;
    }
}
</style>